import ManagerFlightRevenue from './ManagerFlightRevenue';

export default ManagerFlightRevenue;
